<template>
  <v-container class="pa-5">
    <!-- padding around the container (outside the card) -->
    <v-card class="pa-5">
      <!-- padding inside the card -->

      <!-- Title -->
      <v-row>
        <v-col>
          <h3 class="primary--text text-center">Make A Booking</h3>
        </v-col>
      </v-row>

      <!-- Desc -->
      <v-row class="px-3">
        <v-col>
          <div class="text-center">
            <v-btn x-large outlined color="primary" @click="submitChange(date)">Make A Booking</v-btn>
          </div>
          <p>Select a date below to book on that date.</p>
        </v-col>
      </v-row>

      <!--Date Picker -->
      <v-row class="px-5">
        <v-date-picker
          v-model="date"
          full-width
          :landscape="$vuetify.breakpoint.smAndUp"
          @click:date="submitChange"
          height="400px"
        ></v-date-picker>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10)
  }),
  methods: {
    submitChange: function(bookingDate) {
      this.$emit("book", bookingDate);
    }
  }
};
</script>